
import { AbstractControl } from '@angular/forms';
import { format } from 'rut.js';
import { IOption } from '@common/interfaces/input.interface';

export class Utils {

  public getInputError(control: AbstractControl): string {
    if (control.hasError('required')) { return 'Valor requerido'; }
    if (control.hasError('rut')) { return 'El rut ingresado no es válido'; }
    if (control.hasError('minMoney')) {
      return `Debes ingresar un valor mayor o igual a ${this.formatMoney((control.errors?.minMoney.min).toString())}`;
    }
    if (control.hasError('maxMoney')) {
      return `Debes ingresar un valor menor o igual a ${this.formatMoney((control.errors?.maxMoney.max).toString())}`;
    }
    if (control.hasError('min')) { return `Debes ingresar un valor mayor a ${control.errors?.min.min}`; }
    if (control.hasError('max')) { return `Debes ingresar un valor menor a ${control.errors?.max.max}`; }
    if (control.hasError('minlength')) {
      return `Debes ingresar una cantidad mínima de ${control.errors?.minlength.requiredLength} caracteres`;
    }
    if (control.hasError('maxlength')) {
      return `Debes ingresar una cantidad máxima de ${control.errors?.maxlength.requiredLength} caracteres`;
    }
    if (control.hasError('email')) { return 'Ingresa un correo válido'; }
    if (control.hasError('cardNumber')) { return 'Ingresa un Nº de tarjeta válido'; }
    if (control.hasError('password')) { return 'Solo se permiten números y letras'; }
    if (control.hasError('provisoryPassword')) { return 'Ingresa una clave válida'; }
    if (control.hasError('notSame')) { return 'La clave debe coincidir con la de arriba'; }
    if (control.hasError('sameNewPassword')) { return 'La nueva clave debe ser distinta a la actual'; }
    return '';
  }

  public formatRut(rut: string) {
    return format(rut);
  }

  public formatMoney(value: string) {
    return value && `$${value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
  }

  public createNumberRangeOptionsArray(min: number, max: number) {
    const numbers: IOption[] = [];
    for (let _i = min; _i <= max; _i++) {
      numbers.push({ value: _i.toString() });
    }
    return numbers;
  }

  public scrollToId(id: string) {
    const element = document.getElementById(id);
    element?.scrollIntoView(true);
  }

  public downloadBase64File(dataURI: string, type = 'application/pdf') {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }
}
